module.exports = " <div class=multi-choose> <div class=choose-wrap></div> <div class=footer-wrap> <button class=confirm>确定</button> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/popup/bulidChooseMulti/buildChooseMulti.html
// module id = 1980
// module chunks = 50